import styled from "styled-components";
import Layout from "../components/Global/Layout";
import SavedAddressPicker from "../components/Address/SavedAddressPicker";

// Lightweight "My Addresses" management surface. Reuses SavedAddressPicker
// (add / set-primary / delete all work the same as at checkout). Selection is
// a no-op here — this page is purely for managing the saved address book.

const Page = styled.div`
  max-width: 640px;
  margin: 90px auto 40px auto;
  padding: 0 16px;
  font-family: "Poppins", sans-serif;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: #14282d;
  margin-bottom: 6px;
`;

const Sub = styled.p`
  font-size: 13px;
  color: #7a8a90;
  margin: 0 0 18px 0;
`;

const MyAddresses = () => {
  return (
    <Layout>
      <Page>
        <Title>My addresses</Title>
        <Sub>
          Manage your saved delivery addresses. These appear at checkout so you
          can deliver each vendor's order wherever you like.
        </Sub>
        {/* Selection isn't used on the management page. */}
        <SavedAddressPicker onSelect={() => {}} />
      </Page>
    </Layout>
  );
};

export default MyAddresses;
